import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LegalNav } from './PrivacyPolicy';
import './LegalPage.css';

const COOKIE_CONSENT_KEY = 'almaley_cookie_consent';

const CookiePolicy = () => {
  useLocation();

  const [analytics, setAnalytics] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (stored) {
      try {
        const prefs = JSON.parse(stored);
        setAnalytics(prefs.analytics ?? false);
      } catch (_) {}
    }
  }, []);

  const handleSave = () => {
    const prefs = { necessary: true, analytics };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(prefs));
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="legal-page">
      <h1>Política de cookies</h1>
      <p className="legal-updated">Última actualización: octubre de 2026</p>
      <LegalNav />

      <h2>¿Qué son las cookies?</h2>
      <p>
        Las cookies son pequeños archivos de texto que los sitios web almacenan en tu dispositivo cuando los visitas. Permiten que el sitio recuerde información sobre tu visita, como tu idioma preferido y otras opciones.
      </p>

      <h2>Cookies que utilizamos</h2>

      <table className="cookie-table">
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Tipo</th>
            <th>Duración</th>
            <th>Finalidad</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>access_token</code></td>
            <td>Necesaria</td>
            <td>Sesión (el acceso caduca a las 48 horas)</td>
            <td>Mantiene tu sesión iniciada de forma segura (HttpOnly, no accesible desde JavaScript).</td>
          </tr>
          <tr>
            <td><code>almaley_cookie_consent</code></td>
            <td>Necesaria (almacenamiento local)</td>
            <td>Hasta que borres los datos del navegador</td>
            <td>Guarda tus preferencias de cookies para no volver a preguntarte.</td>
          </tr>
          <tr>
            <td><code>_GRECAPTCHA</code> (Google)</td>
            <td>Necesaria (seguridad)</td>
            <td>Hasta 6 meses</td>
            <td>Cookie del servicio reCAPTCHA de Google, que se carga en el registro y en el formulario de contacto para distinguir a las personas de los programas automáticos.</td>
          </tr>
        </tbody>
      </table>

      <p>
        Actualmente Almaley <strong>no utiliza cookies de publicidad ni de rastreo de terceros</strong>. Si esto cambia en el futuro, actualizaremos esta política y volveremos a solicitar tu consentimiento.
      </p>

      <h2>Gestionar mis preferencias</h2>
      <p>Puedes actualizar tus preferencias en cualquier momento desde aquí:</p>

      <div className="cookie-toggle-row">
        <div className="cookie-toggle-info">
          <h3>Cookies necesarias</h3>
          <p>Imprescindibles para que la plataforma funcione. No se pueden desactivar.</p>
        </div>
        <label className="toggle-switch">
          <input type="checkbox" checked disabled />
          <span className="toggle-slider" />
        </label>
      </div>

      <div className="cookie-toggle-row">
        <div className="cookie-toggle-info">
          <h3>Cookies analíticas</h3>
          <p>Actualmente no usamos cookies analíticas. Si las activamos en el futuro, solo se utilizarán si has dado aquí tu consentimiento.</p>
        </div>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={analytics}
            onChange={(e) => setAnalytics(e.target.checked)}
          />
          <span className="toggle-slider" />
        </label>
      </div>

      <button className="cookie-save-btn" onClick={handleSave}>
        {saved ? 'Preferencias guardadas' : 'Guardar preferencias'}
      </button>

      <h2>Cómo eliminar las cookies</h2>
      <p>
        También puedes eliminar o bloquear las cookies directamente desde la configuración de tu navegador. Ten en cuenta que desactivar las cookies necesarias puede impedir el correcto funcionamiento de la plataforma.
      </p>

      <h2>Más información</h2>
      <p>
        Para más información sobre cómo tratamos tus datos personales, consulta nuestra <a href="/legal/privacidad">Política de privacidad</a>. Si tienes preguntas, escríbenos a <a href="mailto:legal@almaley.com">legal@almaley.com</a>.
      </p>
    </div>
  );
};

export default CookiePolicy;
